import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EntidadDto } from '../dto/entidad/entidad.dto';
import { TipoTramiteDTO } from '../modules/tramites/supersalud/models/tipoTramiteDTO';
import {EntidadApiResponse} from "../dto/entidad/entidad-response.dto";

@Injectable({
  providedIn: 'root',
})
export class EntidadService {
  private apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  obtenerEntidades(): Observable<EntidadDto[]> {
    return this.http.get<EntidadDto[]>(`${this.apiUrl}/entidad`);
  }

  obtenerEntidadJustifacil(): Observable<EntidadDto> {
    return this.http.get<EntidadDto>(`${this.apiUrl}/entidad/entidadJustifacil`);
  }

  obtenerTiposTramitePorEntidad(
    idEntidad: number
  ): Observable<TipoTramiteDTO[]> {
    return this.http.get<TipoTramiteDTO[]>(
      `${this.apiUrl}/lista/tipotramite/${idEntidad}`
    );
  }

  modificarTiposTramite(tiposTramite: TipoTramiteDTO[]): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/entidad/modificar-tipos-tramite`, tiposTramite);
  }

  modificarEntidad(entidad: FormData): Observable<void> {
    return this.http.put<void>(`${this.apiUrl}/entidad`, entidad);
  }

  obtenerEntidadPorId(idEntidad: number): Observable<EntidadApiResponse> {
    return this.http.get<EntidadApiResponse>(`${this.apiUrl}/entidad/${idEntidad}`);
  }

}
